var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell-symbol",
    transform: "translate(-4.000000, -2.000000)",
    fill: "#899CB7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 L14,20 C14,21.1045695 13.1045695,22 12,22 C10.8954305,22 10,21.1045695 10,20 Z M19.71,15.71 L18.88,14.88 C18.3172301,14.3179306 18.0007002,13.5553814 18,12.76 L18,10 C18,8.70177872 17.5789328,7.43857703 16.8,6.4 L15.9,5.2 C15.3334369,4.44458247 14.4442719,4 13.5,4 L13,4 L13,2.5 C13,2.22385763 12.7761424,2 12.5,2 L11.5,2 C11.2238576,2 11,2.22385763 11,2.5 L11,4 L10.5,4 C9.55572809,4 8.66656315,4.44458247 8.1,5.2 L7.2,6.4 C6.42106723,7.43857703 6,8.70177872 6,10 L6,12.76 C5.99929979,13.5553814 5.68276995,14.3179306 5.12,14.88 L4.29,15.71 C4.10525584,15.8962606 4.00110462,16.1476601 4,16.41 L4,17 C4,17.5522847 4.44771525,18 5,18 L19,18 C19.5522847,18 20,17.5522847 20,17 L20,16.41 C19.9988954,16.1476601 19.8947442,15.8962606 19.71,15.71 Z",
    id: "bell"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.d6c932803a95920172e587293482e187.svg";
export { ForwardRef as ReactComponent };